/* ==========================================================
   NURÉVE — flüssige Navigation
   1) Kategorien-Menü schließt beim Klick sofort, Scroll-Sperre wird gelöst
   2) dünner Gold-Ladebalken oben als sofortiges Feedback
   3) Kategorie- und Produktseiten werden vorgeladen (Hover / Antippen / Menü öffnen)
   4) Jede Anzeige der Seite (auch Zurück/Vor): kein offenes Menü, keine hängende
      Scroll-Sperre, aktueller Warenkorb-Zähler
   ========================================================== */
(function(){
  if (window.__nrvNavFast) return;
  window.__nrvNavFast = true;

  var hasSpec = !!(window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules'));
  var bar = null;

  function getBar(){
    if (!bar){
      bar = document.createElement('div');
      bar.className = 'nrv-progress';
      bar.setAttribute('aria-hidden', 'true');
      document.body.appendChild(bar);
    }
    return bar;
  }
  function startBar(){
    var b = getBar();
    b.classList.remove('is-on');
    void b.offsetWidth;
    b.classList.add('is-on');
  }
  function stopBar(){ if (bar) bar.classList.remove('is-on'); }

  function header(){ return document.querySelector('[data-nrvh]'); }
  function closeAll(instant){
    var w = header();
    if (w){
      if (instant) w.classList.add('nrvh-instant');
      w.classList.remove('nav-open', 'cart-open');
      if (instant) requestAnimationFrame(function(){ requestAnimationFrame(function(){ w.classList.remove('nrvh-instant'); }); });
    }
    document.body.classList.remove('nrvh-locked');
    /* hängengebliebene Seiten-Sperren lösen (EU-Label-Popup, Horizon-Dialoge), solange kein Dialog offen ist */
    if (!document.querySelector('dialog[open]')){
      document.documentElement.classList.remove('nrv-gw-lock');
      document.documentElement.removeAttribute('scroll-lock');
    }
  }

  /* Warenkorb-Zähler immer frisch vom Server (nie aus dem Browser-Cache) */
  function refreshCartCount(){
    fetch('/cart.js?_=' + Date.now(), { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var n = cart.item_count || 0;
        document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = n; el.hidden = n === 0; });
        document.querySelectorAll('[data-cd-count]').forEach(function(el){ el.textContent = n; });
      }).catch(function(){});
  }

  var done = {};
  function prefetch(href){
    if (hasSpec && !/^\/(pages|search)/.test(href)) return;
    var u;
    try { u = new URL(href, location.href); } catch (e) { return; }
    if (u.origin !== location.origin) return;
    if (u.pathname === location.pathname && u.search === location.search) return;
    if (!/^\/(collections|products|pages)(\/|$)/.test(u.pathname)) return;
    var key = u.pathname + u.search;
    if (done[key]) return;
    done[key] = true;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = key;
    document.head.appendChild(l);
  }

  function prefetchDrawer(){
    var w = header();
    if (!w) return;
    w.querySelectorAll('.nrvh-drawer a[href], .nrvh-nav a[href]').forEach(function(a){ prefetch(a.getAttribute('href')); });
  }

  /* Klick: Menü sofort zu, Ladebalken an */
  document.addEventListener('click', function(e){
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (a.hasAttribute('data-cart-open') || a.hasAttribute('download')) return;
    if (a.target && a.target !== '_self') return;
    var raw = a.getAttribute('href') || '';
    if (raw.charAt(0) === '#' || /^(mailto|tel|javascript):/i.test(raw)) return;
    var u;
    try { u = new URL(a.href, location.href); } catch (x) { return; }
    if (u.origin !== location.origin) return;
    var same = (u.pathname === location.pathname && u.search === location.search);
    if (same && u.hash) return;
    var inHeader = !!a.closest('[data-nrvh]');
    if (inHeader){
      if (same){ e.preventDefault(); closeAll(false); return; }
      closeAll(true);
    }
    if (!same && !/\/checkout/.test(u.pathname)) startBar();
  }, true);

  /* Burger geöffnet: alle Kategorien vorladen */
  document.addEventListener('click', function(e){
    if (e.target && e.target.closest && e.target.closest('[data-nav-open]')) prefetchDrawer();
  }, true);

  /* Hover / Antippen: Ziel vorladen */
  var hoverT;
  document.addEventListener('pointerover', function(e){
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    clearTimeout(hoverT);
    hoverT = setTimeout(function(){ prefetch(a.getAttribute('href')); }, 60);
  }, { passive: true });
  document.addEventListener('touchstart', function(e){
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (a) prefetch(a.getAttribute('href'));
  }, { passive: true });

  /* Jede Anzeige der Seite (auch Zurück/Vor): sauberer Zustand + aktueller Warenkorb-Zähler */
  window.addEventListener('pageshow', function(){
    closeAll(true);
    stopBar();
    refreshCartCount();
    setTimeout(refreshCartCount, 700);
  });
  window.addEventListener('pagehide', function(){
    document.body.classList.remove('nrvh-locked');
    stopBar();
  });
})();
